import { render, staticRenderFns } from "./commentDlg.vue?vue&type=template&id=43d183de&scoped=true"
import script from "./commentDlg.vue?vue&type=script&lang=js"
export * from "./commentDlg.vue?vue&type=script&lang=js"
import style0 from "./commentDlg.vue?vue&type=style&index=0&id=43d183de&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43d183de",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/godata/pipelines/eShop-Portal-Web-Release-Prod/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('43d183de')) {
      api.createRecord('43d183de', component.options)
    } else {
      api.reload('43d183de', component.options)
    }
    module.hot.accept("./commentDlg.vue?vue&type=template&id=43d183de&scoped=true", function () {
      api.rerender('43d183de', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ordercenter/dialog/commentDlg.vue"
export default component.exports